// eslint-disable-next-line import/prefer-default-export
export const isFullyCovered = (coverage: number) => coverage === 100;
